module.exports = __webpack_public_path__ + "static/media/clients_2.9d2277fa.jpg";